<template>
  <div v-if="visible" class="price-compare-float-bar">
    <div class="float-bar__body">
      <div class="float-bar__badge">
        <van-icon name="shield-o" class="float-bar__badge-icon" />
      </div>
      <div class="float-bar__content">
        <span class="float-bar__title">价格保护</span>
        <span class="float-bar__divider">|</span>
        <span class="float-bar__desc">活动商品享市场价对比 · 购物更安心</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PriceCompareBar',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/priceCompareTheme.scss';

.price-compare-float-bar {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  pointer-events: none;
}

.float-bar__body {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 36px;
  padding: 6px 14px 8px;
  background: linear-gradient(
    90deg,
    rgba($price-primary, 0.94) 0%,
    rgba($price-primary-dark, 0.9) 100%
  );
  border-radius: 10px 10px 0 0;
  box-sizing: border-box;
}

.float-bar__badge {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.95);
}

.float-bar__badge-icon {
  font-size: 14px;
  color: $price-primary;
}

.float-bar__content {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  overflow: hidden;
}

.float-bar__title {
  flex-shrink: 0;
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.5px;
}

.float-bar__divider {
  flex-shrink: 0;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.45);
}

.float-bar__desc {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.92);
}
</style>
